/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_lumpsum_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Should I invest a lump sum all at once or split it up?`)
};

const es_sip_lumpsum_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Debería invertir una suma única de una sola vez o dividirla?`)
};

const de_sip_lumpsum_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sollte ich eine Pauschalanlage auf einmal investieren oder aufteilen?`)
};

const nl_sip_lumpsum_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moet ik een eenmalige belegging alles tegelijk beleggen of splitsen?`)
};

const fr_sip_lumpsum_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dois-je investir une somme forfaitaire d'un coup ou la diviser ?`)
};

const it_sip_lumpsum_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devo investire un importo forfettario tutto in una volta o dividerlo?`)
};

const pt_br2_sip_lumpsum_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devo investir um investimento único de uma só vez ou dividi-lo?`)
};

const pt_sip_lumpsum_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devo investir um montante único tudo de uma vez ou dividi-lo?`)
};

const ja_sip_lumpsum_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一括投資をすべて一度に投資するか、分割すべきですか？`)
};

const zh_sip_lumpsum_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我应该一次性投资全部还是分批投资？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_lumpsum_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_lumpsum_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_lumpsum_faq4_q", locale)
	if (locale === "en") return en_sip_lumpsum_faq4_q(inputs)
	if (locale === "es") return es_sip_lumpsum_faq4_q(inputs)
	if (locale === "de") return de_sip_lumpsum_faq4_q(inputs)
	if (locale === "nl") return nl_sip_lumpsum_faq4_q(inputs)
	if (locale === "fr") return fr_sip_lumpsum_faq4_q(inputs)
	if (locale === "it") return it_sip_lumpsum_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_sip_lumpsum_faq4_q(inputs)
	if (locale === "pt") return pt_sip_lumpsum_faq4_q(inputs)
	if (locale === "ja") return ja_sip_lumpsum_faq4_q(inputs)
	return zh_sip_lumpsum_faq4_q(inputs)
};